// Template editor route: fetch the template, hand it to the editor, which
// owns the form, the grouped sections, and the live preview beside them. The
// collapsed History rail below it is the template's audit trail.

import { Spinner } from "@pej/kore/components";
import { createFileRoute } from "@tanstack/react-router";
import { useTemplates } from "@/api/templates";
import { EntityHistory } from "@/features/audit/entity-history";
import { TemplateEditor } from "@/features/templates/template-editor";

export const Route = createFileRoute("/w/$workspaceId/templates/$templateId")({
    // Param-only navigation must remount so the form re-reads fresh
    // defaults — see locations.$locationId.tsx for the full rationale.
    remountDeps: ({ params }) => params,
    component: TemplateEditorPage,
});

function TemplateEditorPage() {
    const { workspaceId, templateId } = Route.useParams();
    const templatesQuery = useTemplates(workspaceId);

    if (templatesQuery.isLoading) {
        return (
            <div className="flex h-full items-center justify-center">
                <Spinner />
            </div>
        );
    }

    const template = templatesQuery.data?.find((t) => t.id === templateId);
    if (!template) {
        return <p className="text-muted-foreground">This template couldn't be found.</p>;
    }

    return (
        <div className="flex flex-col gap-6">
            <h1 className="text-xl font-semibold tracking-tight">{template.name}</h1>
            <TemplateEditor template={template} />
            <EntityHistory targetType="DesignTemplate" targetId={template.id} variant="rail" />
        </div>
    );
}
